import AppComponent from '../base/app-component.ts';

interface RiallineaResult {
  confermate: number;
  archiviateConcorrente: number;
  totale: number;
  altraCassa: { spostate: number; create: number };
  stati: { inValutazione: number; inCessati: number };
}

export class RiallineaDeleghe extends AppComponent {
  static override componentName = 'riallinea-deleghe';

  protected override get templateId() { return 'riallinea-deleghe'; }

  private loading = false;

  protected override buildRenderingData(): Record<string, unknown> {
    return { ...super.buildRenderingData(), loading: this.loading };
  }

  protected override onConnected(): void {
    this.delegate.on<MouseEvent>('click', '[data-action="riallinea"]', (e) => {
      e.preventDefault();
      void this.handleRiallinea();
    });
    this.render();
  }

  private async handleRiallinea(): Promise<void> {
    if (this.loading) return;
    this.loading = true;
    this.render();
    try {
      const result = await this.api.deleghe.riallinea();
      if (result.ok) {
        Weext.toast(this.riepilogo(result.data), { type: 'success' });
        this.ricaricaLista();
      } else {
        Weext.toast(`Errore: ${result.error}`, { type: 'danger' });
      }
    } catch (e) {
      Weext.toast(`Errore: ${(e as Error).message}`, { type: 'danger' });
    } finally {
      this.loading = false;
      this.render();
    }
  }

  private ricaricaLista(): void {
    const lista = document.querySelector('wc-lista-deleghe');
    if (lista && typeof (lista as { ricarica?: unknown }).ricarica === 'function') {
      (lista as unknown as { ricarica: () => void }).ricarica();
    }
  }

  private riepilogo(r: RiallineaResult): string {
    const collocate = r.altraCassa.spostate + r.altraCassa.create;
    const traStati = r.stati.inValutazione + r.stati.inCessati;
    if (r.totale === 0 && collocate === 0 && traStati === 0) return 'Nessuna delega da riallineare';
    return `Riallineate ${r.totale} deleghe: ${r.confermate} confermate, ${r.archiviateConcorrente} archiviate; ${collocate} collocate nella cassa attiva; ${traStati} spostate tra Valutazione e Cessati/Trasferiti`;
  }
}
